export default {
  text: '#020303',
  primary: 'black',
  secondary: 'lightgrey',
  background: '#fdfdfd',
  backgroundSecondary: '#020303',
  light: '#FFF',
  dark: '#020303'
}
